import { useNavigate } from 'react-router-dom';

export default function AdminLanding() {
  const navigate = useNavigate();

  return (
    <div className="content">
      <div className="prog-hero">
        <div className="prog-hero-top">
          <div>
            <div className="prog-kicker">Administration</div>
            <div className="prog-title">Admin workspace</div>
            <div className="prog-subtitle">Company taxonomy, user access, and platform configuration.</div>
          </div>
        </div>
      </div>

      <div className="role-grid" style={{ marginTop: 0 }}>
        <button type="button" className="role-card" onClick={() => navigate('/home')}>
          <h3>Programmes and projects</h3>
          <span>Open operational dashboards and portfolio views.</span>
        </button>
        <button type="button" className="role-card" onClick={() => navigate('/admin/taxonomy')}>
          <h3>Process taxonomy</h3>
          <span>Company process hierarchy, versions, and node dependencies (ADMIN-02).</span>
        </button>
        <button type="button" className="role-card" onClick={() => navigate('/admin/role-types')}>
          <h3>Role types</h3>
          <span>Functional role dictionary and task routing rules — feeds Role Assignments (v0.34).</span>
        </button>
        <button type="button" className="role-card" onClick={() => navigate('/admin/reference-data')}>
          <h3>Reference data</h3>
          <span>Department, teams, sub-teams, countries, skills, and suppliers (ADMIN-03).</span>
        </button>
        <button type="button" className="role-card" onClick={() => navigate('/admin/role-assignments')}>
          <h3>Role assignments</h3>
          <span>BPO, SA, and delegating leads by process node — Detail + Grid views (v0.33).</span>
        </button>
        <button type="button" className="role-card" onClick={() => navigate('/admin/estimation-defaults')}>
          <h3>Estimation defaults</h3>
          <span>Company effort-matrix overrides, extrapolation %, and cost parameters (ADMIN-01).</span>
        </button>
        <button type="button" className="role-card" onClick={() => navigate('/admin/cost-types')}>
          <h3>Cost types</h3>
          <span>Recurring and one-time cost categories for solution option ROM and TCO bake-off.</span>
        </button>
        <button type="button" className="role-card" onClick={() => navigate('/admin/gate-templates')}>
          <h3>Gate deliverable templates</h3>
          <span>Org defaults for stage gate phase deliverables — seed on gate setup.</span>
        </button>
        <button type="button" className="role-card" onClick={() => navigate('/admin/functional-spec-sections')}>
          <h3>Functional spec sections</h3>
          <span>Platform-standard section list for Functional Specifications — Mandatory, Optional, or Skip per org (v0.38).</span>
        </button>
        <button type="button" className="role-card" onClick={() => navigate('/admin/demo')}>
          <h3>Demo programme</h3>
          <span>Regenerate the self-serve demo sandbox cloned from the platform template.</span>
        </button>
        <button type="button" className="role-card" onClick={() => navigate('/admin/users')}>
          <h3>User administration</h3>
          <span>Invite users, assign roles, and manage access.</span>
        </button>
      </div>
    </div>
  );
}
